import React from "react";
import Bg from "./bg.png";
import One from "./../../../assets/hero/1.png";
import Two from "./../../../assets/hero/2.png";
import Three from "./../../../assets/hero/3.png";

const Hero = () => {
  return (
    <>
      <section
        className="py-16 relative overflow-hidden h-[620px]"
        style={{ backgroundImage: `url(${Bg})` }}
      >
        <div className="absolute flex bottom-0 w-full md:left-[5%] md:right-[5%] pt-10">
          <img
            className="hidden md:block w-[15%] relative left-12 h-96"
            src={Two}
            alt=""
          />
          <img className="w-full md:w-[60%] h-80 md:h-96" src={One} alt="" />
          <img
            className="hidden md:block w-[15%] relative right-12 h-96"
            src={Three}
            alt=""
          />
        </div>
        <div className="container mx-auto px-5">
          <div className="flex flex-col items-center justify-center">
            <h1 className="text-5xl font-bold text-center text-white mb-6">
              Unlock Your Potential with EduGenius
            </h1>
            <p className="text-lg font-semibold text-white mb-6">
              Empower Your Learning Journey with Our Innovative Education
              Solutions
            </p>
            <button class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow-lg">
              Get Started Now
            </button>
          </div>
        </div>
      </section>
      



    </>
  );
};

export default Hero;
